import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import BackButton from "../components/BackButton";
import { getCountryCode } from "../Firebase";

function readMobiCountry() {
  try {
    const raw = sessionStorage.getItem("AI_MobiLoginResponse");
    if (!raw) return "";
    const d = JSON.parse(raw);
    return String(d?.Result?.Country || "").toUpperCase();
  } catch {
    return "";
  }
}

const englishFaq = (
  <>
    <h1>AI Avatar</h1>
    <p className="fs-4">
      <strong>Five Digit short code:</strong> 54008/54933/54002/54444
    </p>

    <h1>INFORMATION ABOUT YOUR SUBSCRIPTION</h1>

    <p className="fs-4">
      The AI Avatar offers recreational services, consisting of downloading
      content for mobile phones, such as ringtones, pictures, games, news, star
      sign predictions and other material.
    </p>

    <p className="fs-4">
      After subscribing and payment, you may download certain files in
      compatible mobile phones and devices through AI Avatar.
    </p>

    <p className="fs-4">
      The members of AI Avatar receive their personal link each month, which
      they may use to download different content each time.
    </p>

    <p className="fs-4">
      The Service AI Avatar is provided with a monthly subscription and
      especially you will receive twelve (12) chargeable messages (upon receipt),
      with a charge of 2,29€ each, per month, or up to forty eight (48)
      chargeable messages (upon receipt), with a charge of 0,57€ each, per month
      total charge of 27.48€ per month (including VAT and telco fees). Final
      SMS Price
    </p>

    <p className="fs-4">
      The monthly charge is invoiced automatically through the mobile phone bill
      of your Operator.
    </p>

    <p className="fs-4">
      The use of the Service AI Avatar can be made only if you are aged 18 and
      over, as also it is necessary to have the permission from the person that
      pays the mobile phone bill.
    </p>

    <p className="fs-4">
      The Service AI Avatar in Greece is supported by Mobilly S.M.P.C based in
      Tzaferi 16, P.C. 11854, Gazi, Athens, via its 5-digit codes and technical
      connection.
    </p>

    <p className="fs-4">
      For any question, you may contact Customer Support at phone number
      2104445975 (standard charge from any landline). You may also contact us
      via email to support@psmsgreece.gr
    </p>

    <p className="fs-4">
      If you wish to unsubscribe from this Service, you should send the word{" "}
      <strong>STOP AI</strong> to the code 54008/54933/54002/54444 by a text
      message.
    </p>

    <p className="fs-4">
      The text message for the delete from the Service that is sent to 5-digit
      code number 54008/54933 has a standard text message charge, which may vary
      depending on your mobile phone operator. The confirmation of the delete is
      sent to the subscriber via a free of charge text message that is sent by
      the code 54632.
    </p>
  </>
);

const greekFaq = (
  <>
    <h1>AI Avatar</h1>
    <p className="fs-4">
      <strong>Πενταψήφιος Κωδικός:</strong> 54008/54933/54002/54444
    </p>

    <h1>ΠΛΗΡΟΦΟΡΙΕΣ ΓΙΑ ΤΗΝ ΣΥΝΔΡΟΜΗ ΣΑΣ</h1>

    <p className="fs-4">
      Η AI Avatar παρέχει ψυχαγωγικές υπηρεσίες που συνίστανται στην λήψη
      περιεχομένου για κινητά τηλέφωνα, όπως ήχοι ειδοποίησης, φωτογραφίες,
      παιχνίδια, ειδησεογραφικό υλικό, αστρολογικές προβλέψεις και άλλα
      αντικείμενα.
    </p>

    <p className="fs-4">
      Αφού πραγματοποιήσετε έγκυρη εγγραφή και πληρωμή, μπορείτε να λάβετε
      ορισμένα αρχεία σε συμβατά κινητά τηλέφωνα και συμβατές συσκευές μέσω της
      AI Avatar.
    </p>

    <p className="fs-4">
      Τα μέλη της AI Avatar λαμβάνουν τον προσωπικό τους σύνδεσμο κάθε μήνα, με
      τον οποίο μπορούν να κάνουν λήψη διαφορετικού περιεχομένου κάθε φορά.
    </p>

    <p className="fs-4">
      Η Υπηρεσία AI Avatar παρέχεται με μηνιαία συνδρομή και συγκεκριμένα θα
      λαμβάνετε δώδεκα (12) κατά την λήψη χρεώσιμα μηνύματα, αξίας 2,29€ έκαστο,
      ή έως (48) σαράντα οχτώ κατά την λήψη χρεώσιμα μηνύματα 0,57€ εκαστο
      μηνιαίως, συνολική χρέωση: 27,48€ ανά μήνα (συμπεριλαμβανομένων ΦΠΑ και
      τελών κινητής).{" "}
      <a
        href="https://site.mobilly.gr/"
        target="_blank"
        rel="noopener noreferrer"
        className="faq-inline-link"
      >
        Τελική Τιμή Μηνύματος
      </a>
    </p>

    <p className="fs-4">
      Η μηνιαία χρέωση σας θα τιμολογείται αυτόματα μέσω του λογαριασμού κινητής
      τηλεφωνίας του Παρόχου σας.
    </p>

    <p className="fs-4">
      Απαραίτητη προϋπόθεση χρήσης της Υπηρεσίας AI Avatar είναι να είστε άνω
      των 18 ετών, καθώς και να σας έχει δοθεί η άδεια του ατόμου που πληρώνει
      τον λογαριασμό κινητής τηλεφωνίας.
    </p>

    <p className="fs-4">
      Η Υπηρεσία AI Avatar, στην Ελλάδα υποστηρίζεται από την εταιρεία Mobilly
      Μονοπρόσωπη ΙΚΕ, με έδρα: Τζαφέρη 16, TK 11854 Γκάζι-Αθήνα, Ελλάδα, μέσω
      των 5ψηφίων κωδικών της και της τεχνικής υποδομής της.
    </p>

    <p className="fs-4">
      Για οποιοδήποτε θέμα μπορείτε να επικοινωνήσετε με το Τμήμα
      Εξυπηρέτησης Πελατών τηλεφωνικά στον αριθμό 2104445975 (απλή χρέωση από
      οποιοδήποτε σταθερό τηλέφωνο). Μπορείτε επίσης να επικοινωνήσετε και μέσω
      email στο: support@psmsgreece.gr
    </p>

    <p className="fs-4">
      Εάν επιθυμείτε να διακόψετε τη συνδρομή σας από αυτήν την υπηρεσία,
      στείλτε μήνυμα από το κινητό σας με την λέξη <strong>STOP AI</strong> στον
      κωδικό πενταψήφιο αριθμό 54008/54933/54002/54444 όπου είχατε εγγραφεί
    </p>

    <p className="fs-4">
      Το μήνυμα διαγραφής που αποστέλλει ο συνδρομητής στον πενταψήφιο κωδικό
      54008/54933 έχει κόστος απλού τυπικού μηνύματος, που διαφοροποιείται ανά
      πάροχο κινητής τηλεφωνίας. Η επιβεβαίωση διαγραφής αποστέλλεται στον
      συνδρομητή δωρεάν από τον κωδικό 54632.
    </p>
  </>
);

const FaqGreek = () => {
  const { i18n, t } = useTranslation();
  const [geoCountry, setGeoCountry] = useState("");
  const mobiCountry = useMemo(() => readMobiCountry(), []);

  useEffect(() => {
    getCountryCode()
      .then((c) => setGeoCountry((c || "").trim().toUpperCase()))
      .catch(() => setGeoCountry("OTHER"));
  }, []);

  const lang = (
    i18n.language ||
    localStorage.getItem("i18nextLng") ||
    ""
  )
    .toString()
    .toLowerCase();
  const isGreekLang = lang.startsWith("el");
  const isPolish = lang.startsWith("pl");

  const isGreece = geoCountry === "GR" || mobiCountry === "GR";

  const renderBody = () => {
    if (isPolish && !isGreece) return null;
    if (isGreece) {
      return isGreekLang ? greekFaq : englishFaq;
    }
    return englishFaq;
  };

  return (
    <div className="terms-of-use container mt-2">
      <BackButton title={t("portal.profile.faq")} />
      {renderBody()}
    </div>
  );
};

export default FaqGreek;
